import { siteInfo } from '@/mocks/homeData';

export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>

      <div className="relative w-full max-w-[1400px] mx-auto px-4 md:px-6 py-24 md:py-28">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-5">
              <i className="ri-fire-line"></i>
              <span>每日更新 · 高清不卡顿</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight mb-4">
              {siteInfo.name}
              <span className="block text-primary-600 text-2xl md:text-4xl lg:text-5xl mt-1">
                高清影视在线观看平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-primary-500 font-heading font-semibold mb-6">
              画质清晰不模糊 · 超清影视播放不卡顿
            </p>

            <div className="max-w-xl lg:max-w-none mx-auto lg:mx-0">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                88影视网汇聚海量高清电影电视剧资源，每日追踪全球影视动态，第一时间为观众呈现最新最全的超清影视内容。无论是最新院线大片、热播国产剧集，还是经典口碑佳作、海外精选内容，均支持高清在线观看。平台采用智能CDN加速与自适应画质技术，确保每一位影迷都能畅享流畅不卡顿的极致观影体验。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
                当前站内已收录超过五万部影视资源，覆盖动作、科幻、悬疑、喜剧、爱情、动画等全品类题材。2026暑期档多部重磅大片陆续上线，影视快讯模块实时追踪全球热点，影迷社区持续分享深度解析与观影指南。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-600 font-heading">50,000+</div>
                <div className="text-xs text-foreground-500 mt-0.5">高清影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-600 font-heading">每日更新</div>
                <div className="text-xs text-foreground-500 mt-0.5">全球影视动态追踪</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-600 font-heading">99.7%</div>
                <div className="text-xs text-foreground-500 mt-0.5">流畅播放成功率</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); scrollTo('index'); }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer text-sm"
              >
                开始探索影视资源
              </a>
              <a
                href="#updates"
                onClick={(e) => { e.preventDefault(); scrollTo('updates'); }}
                className="w-full sm:w-auto px-8 py-3.5 border border-foreground-300 text-foreground-700 font-medium rounded-lg hover:bg-background-100 transition-colors text-center whitespace-nowrap cursor-pointer text-sm"
              >
                查看最新快讯
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-200/30 rounded-3xl blur-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20collage%20featuring%20classic%20movie%20reels%2C%20theater%20spotlights%2C%20and%20film%20strips%20in%20warm%20golden%20and%20amber%20tones%2C%20artistic%20movie%20montage%20with%20vintage%20cinema%20aesthetic%2C%20dramatic%20lighting%2C%20rich%20textures%2C%20nostalgic%20film%20atmosphere%2C%20professional%20editorial%20composition%2C%20elegant%20and%20sophisticated&width=800&height=1000&seq=hero-cinematic-collage-01&orientation=portrait"
                alt="88影视网高清影视在线观看平台主视觉"
                className="relative w-full h-auto rounded-2xl object-cover shadow-2xl"
                title="88影视网 - 高清电影电视剧超清影视播放"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}